import { StarIcon } from "@heroicons/react/24/solid";
import { SlLocationPin } from "react-icons/sl";

type Props = {
  name: string;
  rating: number;
  destination: string;
};

const rating_stars = (points: number) => {
  const stars = []
  for (let i = 0; i < points; i++) {
    stars.push(<StarIcon className="w-[20px] h-[20px] text-orange-500" />)
  }
  return stars;
};

export const ListingStayDetailTitle = ({
  rating,
  destination,
  name,
}: Props) => {
  return (
    <div className="listingSection__wrap !space-y-6">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">{name}</h2>

      <div className="flex items-center space-x-4">
       <span className="flex">{rating_stars(rating)}</span>
        <div className="flex content-center">
          <SlLocationPin size={15}  className="self-center"/>
          <span className="ml-1">{destination}</span>
        </div>
      </div>
    </div>
  );
};
